var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.55981 9.63877C2.55981 5.45303 5.95303 2.05981 10.1388 2.05981C14.3245 2.05981 17.7177 5.45303 17.7177 9.63877C17.7177 13.8245 14.3245 17.2177 10.1388 17.2177C5.95303 17.2177 2.55981 13.8245 2.55981 9.63877ZM10.1388 0.0598145C4.84846 0.0598145 0.559814 4.34846 0.559814 9.63877C0.559814 14.9291 4.84846 19.2177 10.1388 19.2177C12.4237 19.2177 14.5218 18.4177 16.1682 17.0824L22.6901 23.6043L24.1043 22.1901L17.5824 15.6682C18.9177 14.0218 19.7177 11.9237 19.7177 9.63877C19.7177 4.34846 15.4291 0.0598145 10.1388 0.0598145Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.628738a55370bab32e85298cbe21273e.svg";
export { ForwardRef as ReactComponent };